/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserPaymentAccountRoleExtendedDto } from './userPaymentAccountRoleExtendedDto';
import { InvoiceDto } from './invoiceDto';
import { InvoiceSimpleDto } from './invoiceSimpleDto';
import { BooleanTimespanDto } from './booleanTimespanDto';
import { UserPaymentAccountRoleSimpleDto } from './userPaymentAccountRoleSimpleDto';
import { AddressDto } from './addressDto';
import { TransactionSimpleDto } from './transactionSimpleDto';


export interface PaymentAccountExtendedDto { 
    id?: number;
    insertTs: string;
    fakturaCustomerRefNo: number;
    accountNumber: number;
    invoiceAddress?: AddressDto;
    accountName: string;
    currency: PaymentAccountExtendedDto.CurrencyEnum;
    preferredPaymentMethod?: PaymentAccountExtendedDto.PreferredPaymentMethodEnum;
    internalComment?: string;
    active: boolean;
    confirmed: boolean;
    userPaymentAccountRoles?: Array<UserPaymentAccountRoleSimpleDto>;
    prePayment: Array<BooleanTimespanDto>;
    transactionList?: Array<TransactionSimpleDto>;
    invoiceList?: Array<InvoiceSimpleDto>;
    balance?: number;
    extendedUserPaymentAccountRoles?: Array<UserPaymentAccountRoleExtendedDto>;
    extendedInvoiceList?: Array<InvoiceDto>;
    activeDevices?: number;
    totalDevices?: number;
    hasCollars?: boolean;
    hasTraps?: boolean;
}
export namespace PaymentAccountExtendedDto {
    export const CurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
    export const PreferredPaymentMethodEnum = {
        CreditCard: 'CREDIT_CARD',
        BankTransfer: 'BANK_TRANSFER'
    } as const;
    export type PreferredPaymentMethodEnum = typeof PreferredPaymentMethodEnum[keyof typeof PreferredPaymentMethodEnum];
}


export type PreferredPaymentMethodEnum = typeof PaymentAccountExtendedDto.PreferredPaymentMethodEnum[keyof typeof PaymentAccountExtendedDto.PreferredPaymentMethodEnum];
